import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TrafficLabelId } from 'src/app/core';

@Pipe({
  name: 'dataRangeTrafficLabelId'
})
export class DataRangeTrafficLabelIdPipe implements PipeTransform {

  transform(formGroup: FormGroup, trafficLabelIndex: number): TrafficLabelId {
    return formGroup.get(`temp_trafficLabels.${trafficLabelIndex}.temp_dataRanges.0.trafficLabelId`).value;
  }

}
